export default __webpack_public_path__ + "static/media/abrace-a-causa.d8420569.png";